import Nav from "../../Components/Nav/Nav"
import Footer from "../../Components/Footer/Footer"
import AddCommentForm from "../../Components/AddCommentForm/AddCommentForm"


export default function AddComments(){
    return(
        <div className="contactMe">  
            <div className="blur-light"></div>
            <Nav />
            <AddCommentForm />
            <Footer />
        </div>
    )
}